import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c5ca0108")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ThumbnailElement = _resolveComponent("ThumbnailElement")

  return (_openBlock(), _createBlock("div", {
    class: "thumbnail-slide",
    style: {
      width: _ctx.size + 'px',
      height: _ctx.size * _ctx.viewportRatio + 'px',
    }
  }, [
    _createVNode("div", {
      class: "elements",
      style: {
        width: _ctx.VIEWPORT_SIZE + 'px',
        height: _ctx.VIEWPORT_SIZE * _ctx.viewportRatio + 'px',
        transform: `scale(${_ctx.scale})`,
      }
    }, [
      _createVNode("div", {
        class: "background",
        style: _ctx.backgroundStyle
      }, null, 4),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.slide.elements, (element, index) => {
        return (_openBlock(), _createBlock(_component_ThumbnailElement, {
          key: element.id,
          elementInfo: element,
          elementIndex: index + 1
        }, null, 8, ["elementInfo", "elementIndex"]))
      }), 128))
    ], 4)
  ], 4))
})